var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.55225H8.3333H34.9997",
    stroke: "currentColor",
    strokeWidth: 2.91686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 9.55169V6.36764C13.332 5.52318 13.6832 4.71331 14.3083 4.11618C14.9334 3.51906 15.7812 3.18359 16.6653 3.18359H23.3319C24.2159 3.18359 25.0638 3.51906 25.6889 4.11618C26.314 4.71331 26.6652 5.52318 26.6652 6.36764V9.55169M31.6652 9.55169V31.84C31.6652 32.6845 31.314 33.4944 30.6888 34.0915C30.0637 34.6886 29.2159 35.0241 28.3318 35.0241H11.6653C10.7813 35.0241 9.93345 34.6886 9.30833 34.0915C8.68322 33.4944 8.33203 32.6845 8.33203 31.84V9.55169H31.6652Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 17.5127V27.066",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 17.5127V27.066",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.5138bc07ac07da8c37a85fcdae4cddf5.svg";
export { ForwardRef as ReactComponent };